// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

function lineWrapper(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.merge([
              Theme__Typography$PrezzeeRibbon.Styles.body,
              BsCssJs$PrezzeeRibbon.style([
                    BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(3)),
                    BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(20)),
                    BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(100)),
                    BsCssJs$PrezzeeRibbon.color(match.regionPicker.deselectedColor)
                  ])
            ]);
}

function selected(theme) {
  var match = theme.components;
  var regionPicker = match.regionPicker;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.backgroundColor(regionPicker.selectedBackgroundColor),
              BsCssJs$PrezzeeRibbon.color(regionPicker.selectedTextColor),
              BsCssJs$PrezzeeRibbon.fontWeight("semiBold"),
              BsCssJs$PrezzeeRibbon.selector("img", [
                    BsCssJs$PrezzeeRibbon.borderColor(regionPicker.selectedIconBorderColor),
                    BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(100))
                  ])
            ]);
}

var Styles = {
  lineWrapper: lineWrapper,
  selected: selected
};

function RegionListLine(props) {
  var onClick = props.onClick;
  var selected$1 = props.selected;
  var selected$2 = selected$1 !== undefined ? selected$1 : false;
  var onClick$1 = onClick !== undefined ? onClick : (function (param) {
        
      });
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  var wrapperClassName = BsCssJs$PrezzeeRibbon.merge(selected$2 ? [
          lineWrapper(theme),
          selected(theme)
        ] : [lineWrapper(theme)]);
  return JsxRuntime.jsx("div", {
              children: props.region.el,
              className: wrapperClassName,
              onClick: onClick$1
            });
}

var make = RegionListLine;

export {
  Styles ,
  make ,
}
/* react/jsx-runtime Not a pure module */
